// extracted by mini-css-extract-plugin
export default {"main":"MoreButton_main__VOMzY","icon":"MoreButton_icon__BaDt-","btn1":"MoreButton_btn1__guQr6","btn2":"MoreButton_btn2__VGfun","btn":"MoreButton_btn__wbnaz"};